import React from 'react'

import { TimedSectionLink } from '@src/types/navigation'

import NavButtonLink from '../NavButtonLink'
import TimedSection from '../section/TimedSection'

type Props = {
  sections: TimedSectionLink[]
  button: { link: string; text: string }
}

export default function TimedSectionsLinkGrid({ sections, button }: Props) {
  return (
    <section className='flex flex-col items-start'>
      <section className='grid grid-cols-2 gap-x-8 gap-y-4 items-start'>
        {sections.map((section) => (
          <TimedSection key={`timed_section__${section.title}`} section={section} />
        ))}
        {sections.length % 2 === 0 && <div className='h-20'></div>}
        <NavButtonLink
          className='my-auto justify-self-start text-r-xl'
          link={button.link}
          text={button.text}
        />
      </section>
    </section>
  )
}
